<template>
    <button 
        class="funcionalidadeDefault"
        :class="[type, selecionado.nome === item.nome ? 'ativo' : '']"
        @click="handleSetSelecionado(item)"
        v-b-tooltip.hover :title="titleTooltip"
    >
        <!-- <img /> -->
        <div class='iconeDefault' v-if="type === 'default'">
            <font-awesome-icon :icon="item.icone" />
        </div>
        <!-- <span></span> -->
        <div class="tituloDefault" v-if="type === 'default'">
            {{ item.nome }}
        </div>
    </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Funcionalidade',
    props: {
        type: String,
        item: {
            nome: '',
            icone: '',
            texto: ''
        }
    },
    data () {
        return {}
    },
    computed: {
        ...mapGetters('modalFuncionalidades', { selecionado: 'getSelecionado' }),
        titleTooltip: function () {
            if (this.type == 'large') {
                return 'Clique para assistir'
            }
            return ''
        }
    },
    methods: {
        ...mapActions('modalFuncionalidades', ['setSelecionado', 'setModo']),
        handleSetSelecionado(selecionado) {
            if (this.type === 'default') {
                this.setSelecionado(selecionado);
            } else {
                this.setModo('video');
            }
        }
    }
}
</script>

<style lang="scss">
.funcionalidadeDefault {
    background-color: #f7f7f7;
    border-radius: 4px;
    // box-shadow: 2px 2px #ddd;
    transition: background-color 0.5s ease;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: #062f46;
        // box-shadow: none;

        .tituloDefault {
            color: #e4b864;
        }
    }

    &.ativo {
        background-color: #062f46;

        .tituloDefault {
            color: #e4b864;
        }
    }

    &.large {
        width: 344px;
        height: 151px;
        background-image: url('../../../assets/images/modalLP/video-apresentacao-rte.png');

        &:hover {
            // box-shadow: 2px 2px #ddd;
            background-color: #f7f7f7;
            opacity: 0.9;
        }
    }
}

.default {
    width: 160px;
    height: 152px;
}

.iconeDefault {
    color: #e4b864;
    font-size: 56px;
}

.tituloDefault {
    width: 108px;
    height: 24px;
    margin-top: 8px;
    text-align: center;

    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
}



</style>
